import React from 'react'
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Col, Container, Row } from 'react-bootstrap';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

const Faqs = () => {
      const [expanded, setExpanded] = React.useState("panel2");
    
      const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };
  return (
    <div>
        <Container className='bw_custome_footer_container '>
        <Row className="w-100 m-auto">
                      <Col sm={12} md={12} lg={12}>
                      <h2 class="sho_heading text-center mb-5">Frequently Asked Questions</h2>
                      </Col>
                    </Row>
                    <Row className="w-100 m-auto">
                      <Col className="p-0 px-md-0">
                        <div
                          className="bw_wdd_faq_accordian"
                        >
                          <Accordion
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel1" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="bw_accordian_heading">
                              What is the timeframe required to develop a Shopify store from scratch? 
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              The time to build a Shopify store from scratch usually takes between 4 to 6 weeks. The timeline depends on the size, features, and complexity of your project. We work fast but never compromise on quality.

                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel2"}
                            onChange={handleChange("panel2")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel2" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="bw_accordian_heading">
                              What is the approximate cost of a Shopify Store?

                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              The cost of creating a Shopify store based on features and design. You pay Shopify for the subscription and a development partner like us for building and maintaining the store. Our development plans typically start around $2200 per year for monthly handling and $2499 one-time setup fee. Pricing may vary depending on your specific needs and requirements.

                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChange("panel3")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel3" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel3a-content"
                              id="panel3a-header"
                            >
                              <Typography className="bw_accordian_heading">
                              Do Shopify experts provide SEO services for my store?

                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              Absolutely. Our Shopify experts offer complete SEO services. We help improve your site speed, structure, keywords, and meta tags, making it easier to attract organic traffic and boost your sales naturally.

                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel4"}
                            onChange={handleChange("panel4")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel4" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel4a-content"
                              id="panel4a-header"
                            >
                              <Typography className="bw_accordian_heading">
                              How can a Shopify expert help improve my online store? 

                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              A Shopify expert can completely transform your online store with custom designs, better functionality, smoother navigation, and implement smart strategies, making it easier for visitors to shop, engage, and keep coming back for more.

                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel5"}
                            onChange={handleChange("panel5")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel5" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel5a-content"
                              id="panel5a-header"
                            >
                              <Typography className="bw_accordian_heading">
                              Can I get support and maintenance for my Shopify store post-launch?

                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              Definitely. After your store goes live, we continue to support you with regular updates, bug fixes, and performance enhancements to keep your business running smoothly and ready for new growth.

                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Col>
                    </Row>
        </Container>
      
    </div>
  )
}

export default Faqs